module.exports = __webpack_public_path__ + "img/accessory-title@2x.bd9a4d15.png";